import { useCallback, useEffect, memo } from 'react'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Markdown from 'components/Markdown'
import { Theme } from '@mui/material/styles'
import withStyles from '@mui/styles/withStyles'
import createStyles from '@mui/styles/createStyles'
import Grow from '@mui/material/Grow'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import { useClientDetails } from 'stores/utils/hooks/useClientDetails'

const StyledPaper = withStyles((theme: Theme) =>
  createStyles({
    root: {
      borderColor: theme.palette.warning.main,
      padding: theme.spacing(2),
      cursor: 'pointer',
      '& a': {
        color: theme.palette.warning.dark,
        textDecoration: 'none'
      },
      '& strong:nth-of-type(2)': {
        fontSize: '20px'
      },
      '&:hover': {
        boxShadow: theme.shadows[3]
      }
    }
  })
)(Paper)

interface HotlineFallbackProps {
  message: string
}

const HotlineFallback = ({ message }: HotlineFallbackProps) => {
  const clientDetails = useClientDetails()

  const handleClick = useCallback(() => {
    trackInAmplitude(AmplitudeEvent.UseHotlineFallback)
  }, [])

  useEffect(() => {
    trackInAmplitude(AmplitudeEvent.ShowHotlineFallback)
  }, [])

  if (!clientDetails?.phone) {
    return null
  }

  return (
    <Grow in>
      <StyledPaper variant="outlined">
        <a href={clientDetails.phone} onClick={handleClick}>
          <Typography component="div" variant="body1" color="inherit">
            <Markdown>{`**${message}**<br><br>Unsere Kreditexperten helfen Ihnen gerne weiter, damit Sie die besten Angebote erhalten.\n\nRufen Sie uns einfach kostenlos an:<br><br>**${clientDetails.phone}**`}</Markdown>
          </Typography>
        </a>
      </StyledPaper>
    </Grow>
  )
}

export default memo(HotlineFallback)
